<template>
  <div class="main-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t('upgrade.addUpgrade') }}</span>
      </div>
      
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
        <!-- 预约ID搜索 -->
        <el-form-item :label="$t('upgrade.appointmentId')" prop="appointmentId">
          <el-row type="flex" align="middle">
            <el-col :span="16">
              <el-input v-model="dataForm.appointmentIdInput" :placeholder="$t('upgrade.enterAppointmentId')" clearable></el-input>
            </el-col>
            <el-col :span="7" :offset="1">
              <el-button type="primary" @click="searchAppointment">{{ $t('upgrade.searchAppointment') }}</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        
        <!-- 预约信息展示 -->
        <div v-if="appointmentData" class="appointment-info">
          <el-alert
            :title="$t('upgrade.appointmentInfo')"
            type="success"
            :closable="false">
          </el-alert>
          <el-descriptions :column="2" border>
            <el-descriptions-item :label="$t('upgrade.appointmentId')">{{ appointmentData.id }}</el-descriptions-item>
            <el-descriptions-item :label="$t('upgrade.coachName')">{{ appointmentData.jiaolianxingming }}</el-descriptions-item>
            <el-descriptions-item :label="$t('upgrade.userAccount')">{{ appointmentData.zhanghao }}</el-descriptions-item>
            <el-descriptions-item :label="$t('upgrade.userName')">{{ appointmentData.xingming }}</el-descriptions-item>
            <el-descriptions-item :label="$t('upgrade.appointmentTime')">{{ formatDate(appointmentData.yuyueshijian) }}</el-descriptions-item>
            <el-descriptions-item :label="$t('upgrade.appointmentStatus')">{{ appointmentData.status }}</el-descriptions-item>
          </el-descriptions>
        </div>
        
        <!-- 升级规则选择 -->
        <el-form-item label="升级规则" prop="ruleId" v-if="appointmentData">
          <el-select
            v-model="dataForm.ruleId"
            filterable
            placeholder="请选择升级规则"
            @change="handleRuleChange"
            style="width: 100%"
          >
            <el-option
              v-for="item in ruleOptions"
              :key="item.id"
              :label="item.upgradeName"
              :value="item.id">
              <span>{{ item.upgradeName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">
                {{ item.upgradeType }} - {{ item.additionalCost }}元
              </span>
            </el-option>
          </el-select>
        </el-form-item>
        
        <!-- 手动填写升级信息 -->
        <div v-if="appointmentData && !dataForm.ruleId">
          <el-form-item label="升级类型" prop="upgradeType">
            <el-input v-model="dataForm.upgradeType" placeholder="请输入升级类型"></el-input>
          </el-form-item>
          <el-form-item label="升级详情" prop="upgradeDetails">
            <el-input
              type="textarea"
              v-model="dataForm.upgradeDetails"
              :rows="4"
              placeholder="请输入升级详情"></el-input>
          </el-form-item>
          <el-form-item label="附加费用" prop="additionalCost">
            <el-input-number
              v-model="dataForm.additionalCost"
              :precision="2"
              :min="0"
              :step="10"
              controls-position="right"></el-input-number>
            <span class="unit">元</span>
          </el-form-item>
        </div>
        
        <!-- 显示规则的详细信息 -->
        <div v-if="selectedRule && appointmentData" class="rule-info">
          <el-descriptions :column="1" border>
            <el-descriptions-item label="升级类型">{{ selectedRule.upgradeType }}</el-descriptions-item>
            <el-descriptions-item label="升级详情">{{ selectedRule.upgradeDetails }}</el-descriptions-item>
            <el-descriptions-item label="附加费用">{{ selectedRule.additionalCost }} 元</el-descriptions-item>
          </el-descriptions>
        </div>
        
        <!-- 提交按钮 -->
        <el-form-item v-if="appointmentData">
          <el-button type="primary" @click="submitForm('dataForm')" :loading="submitLoading">提交升级</el-button>
          <el-button @click="resetForm('dataForm')">重置</el-button>
          <el-button class="btn-close" @click="$router.push('/jiaolianyuyue')">返回</el-button>

        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataForm: {
        appointmentIdInput: '',
        appointmentId: '',
        ruleId: '',
        upgradeType: '',
        upgradeDetails: '',
        additionalCost: 0
      },
      dataRule: {
        appointmentIdInput: [
          { required: true, message: '请输入预约ID', trigger: 'blur' }
        ],
        upgradeType: [
          { required: true, message: '请输入升级类型', trigger: 'blur' }
        ],
        upgradeDetails: [
          { required: true, message: '请输入升级详情', trigger: 'blur' }
        ]
      },
      appointmentData: null,
      ruleOptions: [],
      selectedRule: null,
      submitLoading: false
    }
  },
  created() {
    this.getRules()
    
    // 如果URL中有appointmentId参数，则自动搜索
    const appointmentId = this.$route.query.appointmentId
    if (appointmentId) {
      this.dataForm.appointmentIdInput = appointmentId
      this.searchAppointment()
    }
  },
  methods: {
    // 获取所有升级规则
    getRules() {
      this.$http({
        url: '/jiaolianyuyue/upgraderule/active',
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.ruleOptions = data.data || []
        } else {
          this.ruleOptions = []
        }
      })
    },
    
    // 搜索预约
    searchAppointment() {
      if (!this.dataForm.appointmentIdInput) {
        this.$message.warning('请输入预约ID')
        return
      }
      
      this.$http({
        url: `/jiaolianyuyue/info/${this.dataForm.appointmentIdInput}`,
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 0 && data.data) {
          this.appointmentData = data.data
          this.dataForm.appointmentId = data.data.id
          
          // 检查预约状态
          if (this.appointmentData.status === '已取消') {
            this.$message.warning('该预约已取消，不能添加升级')
          }
        } else {
          this.$message.error('预约不存在或已删除')
          this.appointmentData = null
        }
      }).catch(() => {
        this.appointmentData = null
        this.$message.error('获取预约信息失败')
      })
    },
    
    // 处理规则选择变更
    handleRuleChange(ruleId) {
      if (!ruleId) {
        this.selectedRule = null
        return
      }
      
      this.selectedRule = this.ruleOptions.find(rule => rule.id === ruleId)
      if (this.selectedRule) {
        this.dataForm.upgradeType = this.selectedRule.upgradeType
        this.dataForm.upgradeDetails = this.selectedRule.upgradeDetails
        this.dataForm.additionalCost = this.selectedRule.additionalCost
      }
    },
    
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        
        if (!this.appointmentData) {
          this.$message.warning('请先搜索并选择预约记录')
          return
        }
        
        this.submitLoading = true
        
        // 根据是否使用规则选择不同的提交方式
        if (this.dataForm.ruleId) {
          // 使用规则创建升级
          this.$http({
            url: '/jiaolianyuyue/upgrade/createByRule',
            method: 'post',
            params: {
              appointmentId: this.dataForm.appointmentId,
              ruleId: this.dataForm.ruleId
            }
          }).then(({ data }) => {
            this.submitLoading = false
            if (data && data.code === 0) {
              this.$message.success('升级添加成功')
              this.resetForm(formName)
            } else {
              this.$message.error(data.msg || '操作失败')
            }
          }).catch(() => {
            this.submitLoading = false
            this.$message.error('操作失败，请重试')
          })
        } else {
          // 手动创建升级
          this.$http({
            url: '/jiaolianyuyue/upgrade/create',
            method: 'post',
            params: {
              appointmentId: this.dataForm.appointmentId,
              upgradeType: this.dataForm.upgradeType,
              upgradeDetails: this.dataForm.upgradeDetails,
              additionalCost: this.dataForm.additionalCost
            }
          }).then(({ data }) => {
            this.submitLoading = false
            if (data && data.code === 0) {
              this.$message.success('升级添加成功')
              this.resetForm(formName)
            } else {
              this.$message.error(data.msg || '操作失败')
            }
          }).catch(() => {
            this.submitLoading = false
            this.$message.error('操作失败，请重试')
          })
        }
      })
    },
    
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.appointmentData = null
      this.selectedRule = null
      this.dataForm.appointmentId = ''
      this.dataForm.ruleId = ''
      this.dataForm.upgradeType = ''
      this.dataForm.upgradeDetails = ''
      this.dataForm.additionalCost = 0
    },
    
    // 格式化日期
    formatDate(date) {
      if (!date) return ''
      
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}`
    }
  }
}
</script>

<style scoped>
.main-container {
  padding: 20px;
}
.appointment-info {
  margin: 20px 0;
}
.rule-info {
  margin: 20px 0;
}
.unit {
  margin-left: 10px;
}
</style> 